import {
  CrudFilters,
  HttpError,
  IResourceComponentsProps,
  useCan
} from '@refinedev/core';
import { IInteractiveClass } from 'interfaces/interactive_classes';
import {
  IInteractiveClassFilterForm,
  InteractiveClassListFilter
} from './components/ListFilter';
import { ListLayout } from 'components/layout/layout/ListLayout';
import { ListTable } from './components/ListTable';
import { toRangeDateFilter } from 'services/date';
import { useTable } from '@refinedev/antd';

export const translateKind = (kind: string) => {
  switch (kind) {
    case 'general': {
      return 'Todos';
    }

    case 'graduate_course': {
      return 'Curso regulado';
    }

    case 'classroom': {
      return 'Turma';
    }

    default: {
      return kind;
    }
  }
};

export const translatePriority = (priority: string) => {
  switch (priority) {
    case 'regular': {
      return 'Normal';
    }

    case 'high': {
      return 'Alta';
    }

    default: {
      return priority;
    }
  }
};

export const InteractiveClassesList: React.FC<
  IResourceComponentsProps
> = () => {
  const { data: canList } = useCan({
    resource: 'interactive_classes',
    action: 'list'
  });
  const hasListPermission = !!canList?.can;

  const { tableProps, searchFormProps } = useTable<
    IInteractiveClass,
    HttpError,
    IInteractiveClassFilterForm
  >({
    queryOptions: {
      enabled: hasListPermission
    },
    onSearch: params => {
      const filters: CrudFilters = [];
      const { id, title, professor_id, discipline_id, status, period } = params;

      filters.push(
        {
          field: 'filter[by_id]',
          operator: 'eq',
          value: id
        },
        {
          field: 'filter[by_title]',
          operator: 'eq',
          value: title
        },
        {
          field: 'filter[by_professor_id]',
          operator: 'eq',
          value: professor_id
        },
        {
          field: 'filter[by_discipline_id]',
          operator: 'eq',
          value: discipline_id
        },
        {
          field: 'filter[by_status]',
          operator: 'eq',
          value: status
        },
        {
          field: 'filter[by_range_date][]',
          operator: 'eq',
          value: toRangeDateFilter(period)
        }
      );

      return filters;
    }
  });

  if (!hasListPermission) {
    return null;
  }

  return (
    <ListLayout title="Aulas interativas">
      <InteractiveClassListFilter
        searchFormProps={searchFormProps}
        enabled={hasListPermission}
      />
      <ListTable tableProps={tableProps} />
    </ListLayout>
  );
};
